import config from "../config";

export const chatService = {
    askQuestion,
};

// backend returns errors as { detail } rather than { message }, unlike the other services
function askQuestion(question, token) {
    const requestOptions = {
        method: "POST",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ question }),
    };
    return fetch(`${config.apiUrl}/api/chat/`, requestOptions).then((response) =>
        response.json().catch(() => ({})).then((data) => {
            if (!response.ok) {
                return Promise.reject(new Error((data && data.detail) || response.statusText));
            }
            return data;
        })
    );
}
